import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { authRoute, localToken } from '../utils/constants';

const initialState = {};

const headers = {
  Authorization: `Baerer ${localToken}`,
};

export const Slice = createSlice({
  name: 'general',
  initialState,
  reducers: {
    generalSet: (state, action) => {
      if (action.payload.setLoading) {
        state[action.payload.setLoading] = false;
      }
      state[action.payload.reduxField] = action.payload.value;
    },

    addToArray: (state, action) => {
      if (action.payload.setLoading) {
        state[action.payload.setLoading] = false;
      }
      if (Array.isArray(state[action.payload.reduxField])) {
        state[action.payload.reduxField] = [action.payload.value, ...state[action.payload.reduxField]];
      } else {
        state[action.payload.reduxField] = [action.payload.value];
      }
    },
    addArrayToArray: (state, action) => {
      if (action.payload.setLoading) {
        state[action.payload.setLoading] = false;
      }
      console.log({ value: action.payload.value });
      if (Array.isArray(state[action.payload.reduxField] && Array.isArray(action.payload.value))) {
        state[action.payload.reduxField] = [...action.payload.value, ...state[action.payload.reduxField]];
      } else {
        // state[action.payload.reduxField] = [...action.payload.value, ...state[action.payload.reduxField]];
        //    state[action.payload.reduxField] = [...action.payload.value];
      }
    },
  },
});

export const apiAction = (formData) => async (dispatch) => {
  try {
    const response = await axios.post(`${authRoute}/${formData.route}`, { ...formData }, { headers });
    if (formData.addToArray) {
      dispatch(addToArray({ reduxField: formData.reduxField, setLoading: formData.setLoading, value: response.data }));
    }
    if (!formData.addToArray && formData.addArrayToArray) {
      dispatch(
        addArrayToArray({ reduxField: formData.reduxField, setLoading: formData.setLoading, value: response.data })
      );
    }
    if (!formData.addToArray && !formData.addArrayToArray) {
      dispatch(generalSet({ reduxField: formData.reduxField, setLoading: formData.setLoading, value: response.data }));
    }
  } catch (err) {
    // throw new Error(err);
    console.error(err);
    return { error: err };
  }
};

export const { generalSet, addToArray, addArrayToArray } = Slice.actions;

export default Slice.reducer;
